// Import the main entry file
import './main.js';



// WEBPACK FOOTER //
// /Users/sandersturing/Sites/EXT/snaders/frontend/source/javascript/main-es.js